import { useState } from "react";
import useAsyncModalConfirm from "../../asyncModalConfirm/asyncModalConfirm";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { IconButton, TableCell } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { KOGTableRow } from "../../boxGrid/styles";
import * as S from "./styles";
import LoadingComponent from "../../loading/loadingComponent";
import { supervisionAssignmentApi } from "@/main/api/supervisionAssignmentApi";
import { SupervisorAssignmentResponse } from "@/main/models/response/supervisionAssignmentResponse";
import { toast } from "react-toastify";
import useAsyncModalConfirmReason from "../../asyncModalConfirmReason/asyncModalConfirmReason";
import { ReasonTypeEnum } from "@/main/services/enum/ReasonEnum";
import { toBase64 } from "@/main/services/utilsFile";

interface IRowSupervisorAssignmentProps {
	assignment: SupervisorAssignmentResponse;
	resetFilters: () => void;
}

function RowSupervisorAssignment({ assignment, resetFilters }: IRowSupervisorAssignmentProps) {
	const [isLoadingRemove, setIsLoadingRemove] = useState<boolean>(false);

	const [getConfirmation, ModalConfirmation] = useAsyncModalConfirm();
	const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();

	async function handleRemoveAssignment() {
		if (isNullUndefined(assignment.guid)) {
			return;
		}

		const message = getTranslateByKey("information.confirmRemoveSupervisorAssignment").replace(
			"{0}",
			`${assignment.bodyshopRfc} - ${assignment.bodyshopCompany}`,
		);
		const isConfirmed = await getConfirmation(message);
		if (!isConfirmed) return;

		const resultConfirm = await getConfirmationReason(
			getTranslateByKey("information.confirmChangeTitle"),
			ReasonTypeEnum.ChangeCompany,
		);

		if (!resultConfirm.confirmed) return;

		setIsLoadingRemove(true);

		let filesRequest = undefined;
		if (resultConfirm.files && resultConfirm.files.length > 0) {
			filesRequest = await Promise.all(
				resultConfirm.files.map(async (item) => {
					const base64DataUrl = await toBase64(item);
					return {
						fileName: item.name,
						contentType: item.type,
						fileBase64: base64DataUrl as string,
					};
				}),
			);
		}

		const payload = {
			guidSupervisionAssignment: assignment.guid,
			changeJustification: {
				guidReason: resultConfirm.reason ? String(resultConfirm.reason.key) : null,
				reasonDescription: resultConfirm.observation || null,
				filesUpload: filesRequest,
			},
		};

		supervisionAssignmentApi
			.deleteSupervisionAssingment(payload)
			.then((response) => {
				const resData = response.data;

				if (!isNullUndefined(resData)) {
					toast.success(getTranslateByKey("information.myBodyshopsRemovedSuccessfully"));
					setIsLoadingRemove(false);
					resetFilters();
				}
			})
			.catch(() => {})
			.finally(() => {});
	}

	return (
		<KOGTableRow key={assignment.guid} $notClickable>
			<TableCell width="8%">{assignment.bodyshopRfc}</TableCell>
			<TableCell width="15%" title={assignment.bodyshopCompany}>
				<S.CustomColumn>{assignment.bodyshopCompany}</S.CustomColumn>
			</TableCell>
			<TableCell width="10%">
				{assignment.formatedDate} - {assignment.username}
			</TableCell>
			<TableCell width="18%">{assignment.insurer}</TableCell>
			<TableCell width="2%">
				<S.ActionButtons>
					<IconButton
						id={`id-supervisorAssignment-remove-${assignment.bodyshopCompany}`}
						size="small"
						style={{ width: 24, height: 24, padding: 0 }}
						onClick={() => {
							handleRemoveAssignment();
						}}
					>
						{isLoadingRemove ? <LoadingComponent size={16} /> : <Close fontSize="small" />}
					</IconButton>
				</S.ActionButtons>
			</TableCell>
			<ModalConfirmation />
			<ModalConfirmationReason />
		</KOGTableRow>
	);
}

export default RowSupervisorAssignment;
